import React from "react";
import { useShowActionsMenu } from "../UI/ActionsMenu/hooks/useShowActionsMenu";
import { IconButton } from "../UI/IconButton/IconButton";

export const ThemeActions = ({
  fieldTheme,
  editFieldName,
  showRemoveFieldModal,
}) => {
  const [showMenuActions] = useShowActionsMenu();

  const menuItems = [
    {
      text: "Edit",
      onClick: editFieldName,
      data: fieldTheme,
    },
    {
      text: "Remove",
      onClick: showRemoveFieldModal,
      data: fieldTheme,
    },
  ];

  const menuOptions = {
    items: menuItems,
    minMenuHeight: 35 * menuItems.length,
    offsetY: 7,
  };

  return (
    <div className="buttons-block">
      <IconButton
        iconName={"options"}
        className={"btn-primary IconButton primary trigger-actions-menu"}
        onClick={showMenuActions(menuOptions)}
      />
    </div>
  );
};
